import { render } from "./AdminsList.vue?vue&type=template&id=857cdbe6"
import script from "./AdminsList.vue?vue&type=script&lang=js"
export * from "./AdminsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__